import React, { useState } from 'react'
import { Select, Form } from 'antd'
import { useField } from 'formik'

const FormikSelect = ({ label, name, options, ...props }) => {
  const [field, meta, helpers] = useField(name)
  const [searchValue, setSearchValue] = useState('')

  const handleChange = (value) => {
    helpers.setValue(value, true) // Set shouldValidate to true
    helpers.setTouched(true)
    setSearchValue('') // Clear search after selection
  }

  const handleBlur = () => {
    helpers.setTouched(true)
  }

  const handleSearch = (value) => {
    setSearchValue(value)
  }

  // Filter options based on search value
  const filteredOptions = options.filter((option) =>
    option.label.toLowerCase().includes(searchValue.toLowerCase())
  )

  return (
    <Form.Item
      label={label}
      required
    >
      <Select
        {...props}
        showSearch
        searchValue={searchValue}
        onSearch={handleSearch}
        onChange={handleChange}
        onBlur={handleBlur}
        value={field.value || undefined}
        filterOption={false} // Disable default filtering since we handle it manually
        optionFilterProp="children"
      >
        {filteredOptions.map((option) => (
          <Select.Option key={option.value} value={option.value}>
            {option.label}
          </Select.Option>
        ))}
      </Select>
    </Form.Item>
  )
}

export default FormikSelect
